import { Company, DealerCompany, DealerRepresentative, RegistrationData } from '@/types/registration.types';
import { publicAxiosInstance } from '../../utils/axios';

export const registrationService = {
  async getCompanies(): Promise<Company[]> {
    const response = await publicAxiosInstance.get('/api/v1/accounts');
    return response.data;
  },

  async getDealerCompanies(): Promise<DealerCompany[]> {
    const response = await publicAxiosInstance.get('/api/v1/users/dealer-companies');
    return response.data;
  },

  async getDealerRepresentatives(): Promise<DealerRepresentative[]> {
    const response = await publicAxiosInstance.get('/api/v1/users/dealer-representatives');
    return response.data;
  },

  async register(data: RegistrationData): Promise<{ access_token: string }> {
    const response = await publicAxiosInstance.post('/api/v1/auth/register', data);
    return response.data;
  }
};
